// Extra data the read-only employee profile shows next to the profile itself.
import { buildPagingLiteral, buildWhereLiteral } from '@/lib/graphql-query-builder';

/** Completed MetLife policies of one employee (their own and their dependants'). */
export const buildGetEmployeeInsuranceQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number
) => `
  query {
    MetLifeApplications: getMetLifeApplications(
      where: ${buildWhereLiteral(where)}
      order: []
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      items {
        TypeOfApplication
        MetLifeIdNumber
      }
    }
  }
`;

/** Fines charged to one employee. */
export const buildGetEmployeeFinesQuery = (
  where: Record<string, unknown>,
  pageNo: number,
  pageSize: number
) => `
  query {
    Fines: getFines(
      where: ${buildWhereLiteral(where)}
      order: []
      paging: ${buildPagingLiteral(pageNo, pageSize)}
    ) {
      items {
        FineType
        FineAmount
        FineCreatedDateUtc
      }
    }
  }
`;
